// import cbxLogo from "../../images/product1.png";
import cbxLogo from "../../images/product1.png";
import {
  AiOutlineInteraction,
  // AiOutlineExport,
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlineSetting,
  AiOutlineCheckCircle,
  AiOutlineTeam,
  AiOutlineProfile,
  AiOutlineStock,
} from "react-icons/ai";
import {
  MdOutlinePayment,
  MdSettings,
  MdHolidayVillage,
  MdAccessTime,
  MdCategory,
} from "react-icons/md";
import { FaTruckMoving, FaCarSide } from "react-icons/fa";
import { MdAssignmentLate, MdHowToReg} from "react-icons/md";
import { AiOutlineFileExclamation } from "react-icons/ai";
import { RiUserUnfollowLine } from "react-icons/ri";
import { HiOutlineDocumentAdd } from "react-icons/hi";
import { BsGraphUpArrow } from "react-icons/bs";
import { BiFolderOpen } from "react-icons/bi";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { FaMoneyCheckAlt } from "react-icons/fa";
import { AiOutlineCalendar } from "react-icons/ai";
import { BiCheckCircle } from "react-icons/bi";
import { BsClipboardCheck } from "react-icons/bs";

import { MdPeopleOutline } from "react-icons/md";
import { MdPersonAddAlt } from "react-icons/md";
import { MdAutorenew } from "react-icons/md";
import { MdNoteAdd } from "react-icons/md";
import { MdEventBusy } from "react-icons/md";
import { MdCheckCircleOutline } from "react-icons/md";
import { HiUsers } from "react-icons/hi";

import { Link } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const NewSidebar = () => {
  const [showSampleRequestMenu, setShowSampleRequestMenu] = useState(false);

  //   useEffect(() => {
  //     const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));

  //     const userAccessGroup = currentUserObject[0].accessgrp;

  //     if (
  //       userAccessGroup?.trim().toUpperCase() === "ADMIN" ||
  //       userAccessGroup?.trim().toUpperCase() === "CADMIN" ||
  //       userAccessGroup?.trim().toUpperCase() === "CACCOUNTS" ||
  //       userAccessGroup?.trim().toUpperCase() === "C ACC JUNIOR"
  //     ) {
  //       setShowSampleRequestMenu(true);
  //     }
  //   }, []);

  const navigate = useNavigate();

  const onSignOut = () => {
    localStorage.clear();
    navigate("/");
  };

  const [isOpen, setIsOpen] = useState(true);
  return (
    <aside
      className={`fixed top-0 left-0 h-full w-28 max-h-screen overflow-y-scroll hover:overflow-y-scroll hover:scrollbar-thin hover:scroll-smooth scrollbar-none  scrollbar-thumb-gray-200 scrollbar-track-transparent
           px-4   transition-all duration-300 ease-in-out`}
      // style={{ zIndex: 10, backgroundColor: "#F3F2FA" }}
      style={{ zIndex: 10, backgroundColor: "" }}
    >
      <ul className="space-y-2.5 flex flex-col justify-center items-start w-[65px] mt-24">
        <li className="w-full relative group ">
          <Link
            to="home"
            className="flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95 active:bg-red-500"
          >
            <AiOutlineHome className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
            <span className="text-[0.65rem] font-semibold text-gray-800 group-hover:text-white  transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
              Home
            </span>
          </Link>
        </li>
        <li className="w-full relative group ">
          <Link
            to="emp_reg"
            className="flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
          >
            <MdPersonAddAlt className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
            <span className="mx-1 text-[0.65rem] font-semibold text-gray-800 group-hover:text-white  transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
              Employee Registration
            </span>
          </Link>
        </li>
        <li className="w-full relative group ">
          <Link
            to="emp_list"
            className="flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
          >
            <MdPeopleOutline className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
            <span className="text-[0.65rem] font-semibold text-gray-800 group-hover:text-white  transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
              Employee List
            </span>
          </Link>
        </li>
        <li className="w-full relative group ">
          <Link
            to="bigCalendar"
            className="flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
          >
            <AiOutlineCalendar className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
            <span className="text-[0.65rem] font-semibold text-gray-800 group-hover:text-white  transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
              Events
            </span>
          </Link>
        </li>
        <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
                // background:"#4B5563",
                borderRadius:'4px',
             
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                background:"#4B5563",

                marginTop: "12px !important ",
              text:"#ffffff",
              "& .group": {
          "& .text-gray-700": {
            color: "#ffffff !important", // White icon when expanded
          },
          "& .text-gray-800": {
            color: "#ffffff !important", // White text when expanded
          },
          "& .group-hover\\:text-white": {
            color: "#ffffff", // Ensure hover state retains white
          },
          "& .group-focus\\:text-white": {
            color: "#ffffff", // Ensure focus state retains white
          },
        },
              // borderRadius:"4px"

              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
<li className="w-full relative group">
  <Link
    tabIndex={0}
    role="button"
    className="group flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out 
      group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1  hover:scale-80 active:scale-95 active:mt-2"
  >
    <MdEventBusy className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white group-focus:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
    <span className="text-[0.65rem] font-semibold text-gray-800 group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
      Leave
    </span>
  </Link>
</li>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "2x 0px 2px 0px !important",
            }}
          >
            <li className="w-full relative my-2 ">
              <Link
                to="leaveallotment"
                className="group flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <AiOutlineProfile className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-white group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
                  Allotment
                </span>
              </Link>
            </li>
            <li className="w-full relative my-2   ">
              <Link
                to="leaveapplication"
                className=" group  flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdNoteAdd className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
                  Application
                </span>
              </Link>
            </li>
            <li className="w-full relative my-2   ">
              <Link
                to="leaveapproval" 
                className=" group  flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdCheckCircleOutline className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-white group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
                  Approval
                </span>
              </Link>
            </li>
            <li className="w-full relative my-2   ">
              <Link
                to="leaverejoin"
                className=" group  flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400  group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdAutorenew className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-white group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
                  Rejoin
                </span>
              </Link>
            </li>
            <li className="w-full relative my-2 ">
              <Link
                to="leavecat"
                className=" group  flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdCategory className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-white group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
                  Category
                </span>
              </Link>
            </li>
          </AccordionDetails>
        </Accordion>
        {/* ///////////// */}

        <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
                borderRadius:'4px',
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                margin: "0px !important ",
                 marginTop: "12px !important ",
                background:"#4B5563",
                text:"#ffffff",
                 "& .group": {
          "& .text-gray-700": {
            color: "#ffffff !important", // White icon when expanded
          },
          "& .text-gray-800": {
            color: "#ffffff !important", // White text when expanded
          },
          "& .group-hover\\:text-white": {
            color: "#ffffff", // Ensure hover state retains white
          },
          "& .group-focus\\:text-white": {
            color: "#ffffff", // Ensure focus state retains white
          },
        },
              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
            <li className="w-full relative group">
              <Link
                // to="payroll"
                    tabIndex={0}
    role="button"
                className="group flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95 active:mt-2"
              >
                <MdOutlinePayment className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-gray-800 group-hover:text-white  transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Payroll Management
                </span>
              </Link>
            </li>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "2px 0px 2px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400  group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdOutlinePayment className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Payroll
                </span>
              </Link>
            </li>
          </AccordionDetails>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                to="payroll"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400  group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdOutlinePayment className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Add/<br/>Deduct
                </span>
              </Link>
            </li>
          </AccordionDetails>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group">
              <Link
                to="wps"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400  group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <FaMoneyCheckAlt className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  WPS
                </span>
              </Link>
            </li>
          </AccordionDetails>
        </Accordion>

        <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "0px !important",
                padding: "0px",
                borderRadius:'4px'

              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                margin: "0px !important ",
                background:"#4B5563",

                marginTop: "12px !important ",
              text:"#ffffff",
              "& .group": {
          "& .text-gray-700": {
            color: "#ffffff !important", // White icon when expanded
          },
          "& .text-gray-800": {
            color: "#ffffff !important", // White text when expanded
          },
          "& .group-hover\\:text-white": {
            color: "#ffffff", // Ensure hover state retains white
          },
          "& .group-focus\\:text-white": {
            color: "#ffffff", // Ensure focus state retains white
          },
        }
              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
            <li className="w-16 relative group ">
              <Link
                // to=""
                    tabIndex={0}
    role="button"
                className="group flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdAccessTime className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white transition-all duration-300 group-hover:animate-spin hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-gray-800 group-hover:text-white  transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Attendance
                </span>
              </Link>
            </li>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                to="atdcevaluation"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400  group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <BiCheckCircle className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-ping hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-white group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Evaluation
                </span>
              </Link>
            </li>

            <li className="w-full relative group my-2">
              <Link
                to="timesheet"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400  group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <BsClipboardCheck className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-white group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Timesheet
                </span>
              </Link>
            </li>
          </AccordionDetails>
        </Accordion>

        <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
              },
              
               "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                background:"#4B5563",
                  borderRadius:'4px',

                marginTop: "12px !important ",
              text:"#ffffff",
              "& .group": {
          "& .text-gray-700": {
            color: "#ffffff !important", // White icon when expanded
          },
          "& .text-gray-800": {
            color: "#ffffff !important", // White text when expanded
          },
          "& .group-hover\\:text-white": {
            color: "#ffffff", // Ensure hover state retains white
          },
          "& .group-focus\\:text-white": {
            color: "#ffffff", // Ensure focus state retains white
          },
        },
              // borderRadius:"4px"

              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
            <li className="w-full relative group">
              <Link
                // to=""
                    tabIndex={0}
    role="button"
                className="group flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out  group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95 active:mt-2"
              >
                <MdSettings className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white group-focus:text-white  transition-all duration-300 group-hover:animate-spin hover:scale-110" />

                <span className="text-[0.65rem] font-semibold text-gray-800 group-hover:text-white  group-focus:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Settings
                </span>
              </Link>
            </li>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "2px 0px 2px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                to="holiday"
                className="group flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdHolidayVillage className="w-6 h-6 mb-1 text-white group-hover:text-white group-focus:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />

                <span className="text-[0.65rem] font-semibold text-white  group-hover:text-white group-focus:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Holiday
                </span>
              </Link>
            </li>{" "}
          </AccordionDetails>
        </Accordion>

        <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
              },
               "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                background:"#4B5563",
                  borderRadius:'4px',

                marginTop: "12px !important ",
              text:"#ffffff",
              "& .group": {
          "& .text-gray-700": {
            color: "#ffffff !important", // White icon when expanded
          },
          "& .text-gray-800": {
            color: "#ffffff !important", // White text when expanded
          },
          "& .group-hover\\:text-white": {
            color: "#ffffff", // Ensure hover state retains white
          },
          "& .group-focus\\:text-white": {
            color: "#ffffff", // Ensure focus state retains white
          },
        },
              // borderRadius:"4px"

              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
            <li className="w-full relative group">
              <Link
                // to="payroll"
                className="group flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out  group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <FaTruckMoving className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white group-focus:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-gray-800 group-hover:text-white group-focus:text-white  transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Fleet Management
                </span>
              </Link>
            </li>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600   transition-all duration-200 ease-in-out group-hover:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <FaCarSide className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white group-focus:text-white  transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Fleet Registration
                </span>
              </Link>
            </li>
          </AccordionDetails>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdAssignmentLate className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Registration Expiry
                </span>
              </Link>
            </li>
          </AccordionDetails>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <AiOutlineFileExclamation className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" /> 
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Insurance Expiry
                </span>
              </Link>
            </li>
          </AccordionDetails>
        </Accordion>

        <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                background:"#4B5563",

                marginTop: "12px !important ",
              text:"#ffffff",
              borderRadius:"4px",

              "& .group": {
          "& .text-gray-700": {
            color: "#ffffff !important", // White icon when expanded
          },
          "& .text-gray-800": {
            color: "#ffffff !important", // White text when expanded
          },
          "& .group-hover\\:text-white": {
            color: "#ffffff", // Ensure hover state retains white
          },
          "& .group-focus\\:text-white": {
            color: "#ffffff", // Ensure focus state retains white
          },
        },

              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
            <li className="w-full relative group">
              <Link
                // to="payroll"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <RiUserUnfollowLine className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white group-focus:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-gray-800 group-hover:text-white group-focus:text-white  transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  End of Service
                </span>
              </Link>
            </li>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <HiOutlineDocumentAdd className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Application
                </span>
              </Link>
            </li>
          </AccordionDetails>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdHowToReg className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Approval
                </span>
              </Link>
            </li>
          </AccordionDetails>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <BsGraphUpArrow className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Gratuity Monitor
                </span>
              </Link>
            </li>
          </AccordionDetails>
        </Accordion>

        <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
              },

               "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                background:"#4B5563",

                marginTop: "12px !important ",
              text:"#ffffff",
              borderRadius:"4px",
              "& .group": {
          "& .text-gray-700": {
            color: "#ffffff !important", // White icon when expanded
          },
          "& .text-gray-800": {
            color: "#ffffff !important", // White text when expanded
          },
          "& .group-hover\\:text-white": {
            color: "#ffffff", // Ensure hover state retains white
          },
          "& .group-focus\\:text-white": {
            color: "#ffffff", // Ensure focus state retains white
          },
        },

              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
            <li className="w-full relative group">
              <Link
                // to="payroll"
                className="group flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out  group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <BiFolderOpen className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white group-focus:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-gray-800 group-hover:text-white group-focus:text-white  transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Document Manage
                </span>
              </Link>
            </li>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <BiFolderOpen className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.50rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Document Management
                </span>
              </Link>
            </li>
          </AccordionDetails>
          
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group mt-2">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdEventBusy className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Document Expiry
                </span>
              </Link>
            </li>
          </AccordionDetails>
        </Accordion>

        {/* <li className="w-full relative group">
              <Link
                // to="holiday"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdSettings className="w-6 h-6 mb-1 text-gray-700 group-hover:text-white transition-all duration-300 group-hover:animate-spin hover:scale-110" />
                <span className="text-[0.65rem] font-semibold text-gray-800 group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                Settings
                </span>
              </Link>
            </li>{" "} */}

        <li className="w-full relative group my-4">
          <div className="flex ">
            <img className=" object-cover" src={cbxLogo} alt="" />
          </div>
        </li>
        {/* ///////////// */}
        {/* <div className="">
          <button
            onClick={onSignOut}
            className="flex justify-center items-center w-full bg-red-500 text-white p-2 rounded"
          >
            <div className="flex flex-col justify-center items-center text-center ">
              <AiOutlineExport className="w-6 h-6" />
              <span className="text-xs">Sign Out</span>
            </div>
          </button>
        </div> */}
      </ul>
    </aside>
  );
};

export default NewSidebar;
